import StillWorkingOn from '../StillWorkingOn.js'


const Reels = () => {
  return (
    <div className='w-full max-w-screen-md m-auto min-h-[100dvh] bg-white flex'>
      <StillWorkingOn />
    </div>
  )
}

export default Reels
